import { ImageCollectorDto } from './dto/ImageCollectorDto';
import { Photo } from './Photo';

export class ImageCollector extends ImageCollectorDto {
    photo: Photo;
    active: boolean
    blobStorId: number;
    catDetMobileModuleId: number;
    createdDate: Date;
    imageCollectorId: number;
    lastDateUpdate: Date;
    organizationId: string;
}
